import theme from 'constants/theme';
import styled from 'styled-components';

export const QueueSelectorContainerCustom = styled.button<{ width: number; selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 64px;

  width: ${({ width }) => width}px;
  height: 100%;

  padding: 6px;
  white-space: nowrap;
  position: relative;

  ${({ selected }) =>
    selected
      ? {
          backgroundColor: theme.colors.RC03_1,
          border: `1px solid ${theme.colors.RC03}`,
          zIndex: 1,
        }
      : { backgroundColor: theme.colors.RG00, border: `1px solid ${theme.colors.RG06}` }}
  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &:not(:last-child) {
    margin-right: -1px;
  }

  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  &:disabled {
    background-color: #eceef4;
    border-right-color: 1px solid ${theme.colors.RG06};
    border-top-color: 1px solid ${theme.colors.RG06};
    border-bottom-color: 1px solid ${theme.colors.RG06};
    color: #6e7280;

    cursor: not-allowed;
  }

  cursor: pointer;
`;
